export const SEXES = {
    M: {text: 'Male', value: 'M'},
    F: {text: 'Female', value: 'F'}
};

export const YESNO = [
    {text: 'No', value: 0},
    {text: 'Yes', value: 1}
];

export const BLOOD_TYPES = [
    {text: 'O−', value: 'O−'},
    {text: 'O+', value: 'O+'},
    {text: 'A−', value: 'A−'},
    {text: 'A+', value: 'A+'},
    {text: 'B−', value: 'B−'},
    {text: 'B+', value: 'B+'},
    {text: 'AB−', value: 'AB−'},
    {text: 'AB+', value: 'AB+'},
];